module.exports = __webpack_public_path__ + "img/sub23.2cc4c884.jpg";